import { render, staticRenderFns } from "./PolicyCommissions.vue?vue&type=template&id=fef2cb30"
import script from "./PolicyCommissions.vue?vue&type=script&lang=js"
export * from "./PolicyCommissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports